(function(){
       'use strict'; 
    jQuery(document).ready(function($) {
      function check_compare(value){
              for (var i = 1; i <=8; i++) {
                if (compare_list['p' + i] == value ) {
                    return true
                  break;
                } 
              }
              return false;
          }
      function readMore(string, maxWords) {       
              var strippedString = $("<p>" + string + "</p>").text().trim();      
              var array = strippedString.split(" ");
              var string = array.splice(0, maxWords).join(" ");

              if(array.length > maxWords) {
                string += "...";
              }

              return string ;
            }
      function roadtip(element) { 
              var tipText = element.html();
              element.bind('mouseover', function() {
                if (jQuery('.roadtip').length == 0) {
                  element.before('<span class="roadtip">' + tipText + '</span>');

                  var tipWidth = jQuery('.roadtip').outerWidth();
                  var tipPush = -(tipWidth / 2 - element.outerWidth() / 2);
                  jQuery('.roadtip').css('margin-left', tipPush);
                }
              });
              element.bind('mouseleave', function() { 
                jQuery('.roadtip').remove();
              });
            }
      function convert_currency(value,type){

                try{
                  var newCurrency = Currency.currentCurrency;
                }catch(ex){
                  var newCurrency = '';
                }
                try{
                  var oldCurrency = shopCurrency;
                }catch(ex){
                  var oldCurrency = '';
                }
                if(isNaN(value)){
                    value =  0.0; 
                }
 
                var cents = 0.0;
                var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                if(type == 'format'){
                  return  Currency.formatMoney(value, newFormat);
                }
                if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                    cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                }
                else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
                    cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
                }
                else { 
                    cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
                }
                if(type  == 'nosymbol'){
                    return cents;
                }
                var my_data =  Currency.formatMoney(cents, newFormat);
                return my_data;
       
      }
      function get_symbol(value){
          var str = value.split("");
          var sym = '';
          for(var i=0;i<str.length;i++){
            if(isNaN(str[i])){
                sym+=str[i];
            }else{
              return sym; 
            }
          }
          return sym;
      }
      function get_price_only(price){
       var  price_convert= price.toString();
        var get_currencies = 0;
         var $split = price_convert.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( price_convert.substring(1,0)))) ?  $split[1]:  $split[0];
                }else{
                   get_currencies =price_convert.replace(/[^0-9.]/g, '');
                }
                get_currencies = $.trim(get_currencies); 
                var check = get_currencies.substring(1,0);
                if(isNaN((check))){
                get_currencies =   get_currencies.replace(check,'');
                }
          return parseFloat(get_currencies);

      }
      
      
      
      

        var max_price_slide = convert_currency(99999,'');
        var get_currencies = convert_currency(99999,'');
        var min_price_slide = convert_currency(0,'');
         
        var $split = get_currencies.split(';');
        if($split.length > 1){
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

        }else{
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
        }

      
       $slider_filter = $('#slider-range').slider({
            range: true,
            min: get_price_only(min_price_slide),
            max: get_price_only(max_price_slide),
            values: [get_price_only(min_price_slide), get_price_only(max_price_slide)],
            slide: function(event, ui) {
                var max_price_slide = convert_currency(99999,'');
                var get_currencies = convert_currency(99999,'');
                var min_price_slide = convert_currency(0,'');
                var $split = get_currencies.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

                }else{
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
                }
                var max_pr = get_currencies + ' ' + ui.values[1];
                var min_pr =  get_currencies +' ' + ui.values[0];

                $(".amount-range-price .from span").html(min_pr);
                $(".amount-range-price .to span").html(max_pr);
            },
            change: function(event, ui) {

              var view_mode = ($(".show-grid").hasClass('active')) ? '.show-grid' : '.show-list';
              $(".orderby").hide();
                $("#loading").show(0);
                var max_price = ui.values[1];
                var min_price =ui.values[0];
                 
                var check = 1;
                var sum_product   = 0;
                var page = 0;
                var count;
                $("#collection-product").empty();
                $(".woocommerce-pagination.navigation .page-numbers.nav-links").empty();
                var html = '';
                var view =$(".change-view.active").data('view');
                var has_product = false;
                 console.log(json_collection_filter.length);
                $.each(json_collection_filter,function(index, elem) {
                var current_price =  convert_currency(elem.price,'');
                    current_price = get_price_only(current_price);
                    if (current_price <= max_price && current_price >= min_price) {                          
                      
                      has_product = true;
                      if (sum_product  % 9 === 0) {
                        page++;
                        var count = (sum_product / 9) + 1;
                        $(".woocommerce-pagination.navigation .page-numbers.nav-links").append('<span class="page"><a id= "count_'+count+'" class="paginate' + count + '" >' + count + '</a></span>');
                      }

                      html = html + '<li class="product-item list page_count_'+page+' view-list">';
                      html = html + json_to_html(elem);

                      html +='<li class="product-item view-grid page_count_'+page+' col-md-4 col-sm-6 col-xs-12">';  
                      html = html + json_to_html_grid(elem);                      

                      sum_product++;
                    } 
                               
                    check++;
                });
                  
              if (sum_product  <= 9) {
                    $(".woocommerce-pagination.navigation .page-numbers.nav-links").hide();
              }

                if(! has_product){
                  html +='<p class="text-center"> No products were found matching your selection.</p>';
                }
                $("#collection-product").append(html);                

                $(view_mode).trigger('click');

                window.setTimeout(function() {
                     $("#loading").hide(700);
                }, 1000);

                $("#count_1").trigger("click");
            } 

        });   
        
        function json_to_html(product){
         // shop-products
         var  is_sale = false;
         
         var $html = '';
              $html +='<div class="product-inner">';
              $html +='<div class="thumb col-sm-5 col-md-4 has-second-image">';
              $html +='<a class="thumb-inner" href="'+product.handle+'">';
              $html +='<img src="'+product.featured_image+'" alt="'+product.title+'">';
              if(product.images.length > 1)
                {
                  $html +='<img  class="second-image" src="'+product.images[1]+'" alt="'+product.title+'"/>';
                }
              $html += '</a>';
              $html +='<div class="flash-all">';
              if (product.available == false){
                  $html += '<div class="flash flash-sold_out">';
                  $html += '<span class="sold_out">Sold Out</span>';
                  $html += '</div>';
                }
              else{
                if(product.compare_at_price > product.price){
                    $html +='<div class="flash flash-sale">';
                    $html +='<span class="sale">Sale</span>';
                    $html +='</div>';
                }
              }          
              $html +='</div>';
          	  $html +='<a class="button quick-view yith-wcqv-button" href=\'/products/'+product.handle+'\' data-pid="'+product.variants[0].id +'">Quick View</a>';          
              $html +='</div>';
              $html +='<div class="info col-sm-7 col-md-8">';
              $html +='<h3 class="product-name"><a href=\'/products/'+product.handle+'\'>'+product.title+'</a></h3> ';
              $html +='<span class="price">';
              $html +='<ins><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'xx')+'">'+convert_currency(product.price,'xx')+'</span></ins>';
              if(convert_currency(product.compare_at_price,'nosymbol') > 0){
                $html += '<del><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.compare_at_price,'11')+'">'+convert_currency(product.compare_at_price,'11')+'</span></del>'; 
              }
              $html +='</span>';
          
              $html +='<div class="product-desc">';
              $html += '<p>'+  readMore(product.content, 30) +'</p>';
              $html +='</div>';
              $html +='<div class="list-group-button">';
              if(is_customers){
                if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                  $html +='<a class="view-added-wishlist " title="View my Wishlist" href="/collections/wishlist"></a>';
                  }else{
                      $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="'+product.id+'"></a>';
                      $html +='<a href="/collections/wishlist" class="added-wishlist"  data-toggle="tooltip" data-placement="top"></a>';
                  }
                }else {
                    $html += '<a class="wishlist-login"   href="javascript:void(0)" title="Login to use wishlist"></a>';
                  }
          
              if (product.available == false){
                  $html += '<a class="button btn-sold-out add_to_cart_button" onclick="location.href=\'/products/'+product.handle+'\'"></a>';
                }else{

              if((product.variants).length> 1){
                  $html += '<a class="button select-option" onclick="location.href=\'/products/'+product.handle+'\'"><i class="fa fa-bars"></i></a>';
                }else{
                  $html += '<a class="button add_to_cart_button luckyshop__add-to-cart" data-pid="'+product.variants[0].id+'"></a>';
                  $html += '<span class="adding-cart"></span>';
                }
              }
             
              if(check_compare(product.handle)){
                $html +='<a class="button compare added" href="" data-pid="'+product.handle+'"></a>';
              }else{
                $html +='<a class="button compare" href="" data-pid="'+product.handle+'"></a>';
              }
              $html += '</div>';
              $html += '</div>';
              $html += '</div>';
              $html += '</li>';
              return $html ;
        }

        function json_to_html_grid(product){
          
          var $html = '';
          $html +='<div class="product-inner">';
          $html +=' <div class="thumb has-second-image">';
          $html +='<a href="'+product.handle+'">';
          $html += '<img src="'+product.featured_image+'" alt="'+product.title+'">';
          $html += '</a>';
          if(product.images.length > 1)
            {
              $html +='<a class="second-image" href="'+product.handle+'">';
              $html +='<img src="'+product.images[1]+'" alt="'+product.title+'"/>';
              $html += '</a>'; 
            }
          $html +='<div class="group-button">';
          if(is_customers){
              if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                $html +='<a class="view-added-wishlist " title="View my Wishlist" href="/collections/wishlist"></a>';
                }else{
                  
                    $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="'+product.id+'"></a>';
                    $html +='<a href="/collections/wishlist" class="added-wishlist"  data-toggle="tooltip" data-placement="top" ></a>';
                }
              }else {
                  $html += '<a class="wishlist-login"   href="javascript:void(0)" title="Login to use wishlist"></a>';
                }
          
          if (product.available == false){
              $html += '<a class="button btn-sold-out add_to_cart_button" onclick="location.href=\'/products/'+product.handle+'\'"></a>';
            }else{

          if((product.variants).length> 1){
              $html += '<a class="button select-option" onclick="location.href=\'/products/'+product.handle+'\'"><i class="fa fa-bars"></i></a>';
            }else{
              $html += '<a class="button add_to_cart_button luckyshop__add-to-cart" data-pid="'+product.variants[0].id+'"></a>';
              $html += '<span class="adding-cart"></span>';
            }
          }
          
          if(check_compare(product.handle)){
                $html +='<a class="button compare added" href="" data-pid="'+product.handle+'"></a>';
              }else{
                $html +='<a class="button compare" href="" data-pid="'+product.handle+'"></a>';
              }
          $html +='</div>';
          $html +='<div class="flash-all">';
          if (product.available == false){
              $html += '<div class="flash flash-sold_out">';
              $html += '<span class="sold_out">Sold Out</span>';
              $html += '</div>';
            }
          else{
            if(product.compare_at_price > product.price){
            	$html +='<div class="flash flash-sale">';
                $html +='<span class="sale">Sale</span>';
                $html +='</div>';
            }
          }          
          $html +='</div>';   
          $html +='<a class="button quick-view yith-wcqv-button" href=\'/products/'+product.handle+'\' data-pid="'+product.variants[0].id +'">Quick View</a>';
          $html +='</div>';
          $html +='<div class="info">';
          $html += '<h3 class="product-name short"><a href=\'/products/'+product.handle+'\'>'+product.title+'</a></h3>';
          $html +='<span class="price">';
          $html +='<ins><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'xx')+'">'+convert_currency(product.price,'xx')+'</span></ins>';
          if(convert_currency(product.compare_at_price,'nosymbol') > 0){
            $html += '<del><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.compare_at_price,'11')+'">'+convert_currency(product.compare_at_price,'11')+'</span></del>'; 
          }
          $html +='</span>';
          $html += '</div>';
          $html += '</div>';
          $html += '</li>';
          return $html ;
        }
      
    });
})(jQuery);